export default function getBrowserTimezone() {
  if (
    typeof Intl === "undefined" ||
    typeof Intl.DateTimeFormat === "undefined"
  ) {
    return "Europe/Moscow";
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Moscow";
  } catch {
    return "Europe/Moscow";
  }
}
